import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;

  .filter-checkbox {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    user-select: none;
    white-space: nowrap;

    &.disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }

    input[type='checkbox'] {
      display: none;
    }

    .checkbox {
      display: inline-block;
      width: 16px;
      height: 16px;
      position: relative;
      flex-shrink: 0;

      &:before {
        transition: all 0.3s ease-in-out;
        content: '';
        position: absolute;
        z-index: 1;
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid ${(props) => props.theme.colors.inactive};
        border-radius: 4px;
        box-sizing: border-box;
      }

      &:after {
        transition: all 0.3s ease-in-out;
        content: '';
        position: absolute;
        width: 16px;
        height: 16px;
        background: transparent;
        z-index: 0;
        border-radius: 4px;
        box-sizing: border-box;
      }
    }

    input[type='checkbox']:checked + .checkbox {
      &:after {
        background: ${(props) => props.theme.colors.main_cta};
        transition: all 0.2s ease-in;
      }

      &:before {
        left: 5px;
        top: 2px;
        width: 6px;
        height: 11px;
        border: solid ${(props) => props.theme.colors.inactive};
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        background: transparent;
      }
    }

    .label {
      font-size: 13px;
      color: ${(props) => props.theme.colors.text};
    }
  }

  .merge-toggle {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    user-select: none;
    white-space: nowrap;
    background: none;
    border: none;
    padding: 0;
    color: inherit;

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }

    .switch {
      position: relative;
      width: 36px;
      height: 20px;
      border-radius: 100px;
      background: ${(props) => props.theme.colors.inactive};
      transition: background 0.2s ease-in-out;
      flex-shrink: 0;

      &.on {
        background: ${(props) => props.theme.colors.main_cta};
      }

      .knob {
        position: absolute;
        top: 2px;
        left: 2px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: ${(props) => props.theme.colors.white};
        transition: transform 0.2s ease-in-out;
      }

      &.on .knob {
        transform: translateX(16px);
        background: ${(props) => props.theme.colors.black};
      }
    }

    .label {
      font-size: 13px;
      color: ${(props) => props.theme.colors.text};
    }
  }
`;

export default { Wrapper };
